module.exports = __webpack_public_path__ + "static/media/long-arrow-left.504764af.svg";